import { useParams } from "react-router";
import { DaResetLinkExpired } from "../../components/DaResetLinkExpired/DaResetLinkExpired";

function DaResetLinkExpiredPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaResetLinkExpired /> : null}
    </div>
  );
}

export default DaResetLinkExpiredPage;
